import { Injectable} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {State as CoreState} from '@emm/core/store/core.reducer';
import { AttributesSelectors } from './attributes.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import { Attribute } from '@emm/core/models/attribute.model';

export interface AttributesQueries extends AsyncActionQueries {
    all$: Observable<Attribute[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AttributesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, AttributesSelectors);
    }

    dispatch = {};

    queries: AttributesQueries = {
        all$: this.selectNonNil(AttributesSelectors.getValidAll),
        ...this.asyncActionQueries,
    };

}
